export default "<div class=\"image-view-container\">\n  <img\n    [src]=\"data.imageUrl\"\n    alt=\"\"\n  />\n</div>\n"